import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  DateRangPickerField,
} from "../../../../_metronic/_partials/controls";
import moment from "moment";
import { Formik } from "formik";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import ExportDataTableButton from "../../../components/ExportDataTableButton";

import * as actions from "./_redux/Action";

import { columns_ads_log } from "./columns";
import * as UIHelpers from "../../../components/UIHelpers";
import DataTable from "../../../components/DataTable";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../../../_metronic/_helpers";
// import './ContestList.css';
import { useParams, useHistory } from "react-router-dom";
import helperFunc from "../../../../_metronic/_helpers/helperFunc";

import DropdownReactSelect from "../../../components/DropdownReactSelect";
import "../../../../_metronic/_assets/sass/customstyle.react.scss";

export const initialFilter = {
  sort: "desc", // asc||desc
  sortBy: "date",
  skip: UIHelpers.skip,
  limit: UIHelpers.limit,
  page: UIHelpers.page,
  dateRange: null, //{from: moment().toDate(), to: moment().toDate()}
  fromDate: null,
  toDate: null,
  q: "",
  // filter: {
  //   game: "",
  //   gameType: "",
  // },
  fields: {},
  search: {},
  company: "GJ",
};

export default function Adslogs(props) {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Ads Log List");

  const dispatch = useDispatch();

  const { currentState } = useSelector(
    (state) => ({ currentState: state.newAdscompanylistSlice }),
    shallowEqual
  );
  // const { loginUserCompany } = gameState;
  const {
    entities,
    totalCount,
    listLoading,
    exportData,
    coinStoresForEdit,
  } = currentState;

  const [filter, setFilter] = useState(initialFilter);
  const [dateRange, setDateRange] = useState({
    from: moment(new Date().setHours(0, 0, 0, 0)),
    to: moment(new Date().setHours(23, 59, 59, 999)),
  });

  const [rows, setRows] = useState([]);
  const [allColumns, setAllColumns] = useState(columns_ads_log);
  const [cols, setCols] = useState(columns_ads_log);
  const [selectedSignup, setSelectedSignup] = useState(null);
  const [searchApply, setSearchApply] = useState(false);
  const [showColumnModal, setShowColumnModal] = useState(false);
  const [isShowSidepanel, setIsShowSidepanel] = useState(false);
  const [Signup, setSignup] = useState("");
  const history = useHistory();
  const SignupDropdownFilterData1 = [
    { value: "Click", label: "Click" },
    { value: "View", label: "View" },
    { value: "Impression", label: "Impression" },
  ];

  const handleSignupChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedSignup(selectedOption);
      setSignup(selectedOption.value);
    } else {
      setSelectedSignup(null);
      setSignup("");
    }
  };
  useEffect(() => {
    console.log("entities: ", entities);
    if (entities && entities.length > 0) {
      setRows(entities);
    } else {
      setRows([]);
    }
  }, [entities]);
  const viewItemProfile = (t) => {
    console.log("t=", t);
    const selectedCompanyCode = localStorage.getItem('selectedCompanyCode');
    if (t && selectedCompanyCode) {
      window.open(`/user-profile/${t?.user_id}/${selectedCompanyCode}`);
    }
  };
  useEffect(() => {
    var tampFilter = { ...filter };
    let temp1 = [];
    let selectedFields = {};

    let temp_columns = columns_ads_log.map((value, i) => ({
      ...value,
      id: i,
    }));

    columns_ads_log.map((value, i) => {
      if (value?.show === true) {
        selectedFields[value?.dataField] = 1;
      }
    });

    setCols(temp_columns);

    tampFilter.fields = selectedFields;
    setFilter(tampFilter);

  

    // temp1.push({
    //   dataField: "action",
    //   text: "Actions",
    //   sort: false,
    //   show: true,
    //   format: {
    //     type: "action",
    //     style: {
    //       width: "150px",
    //     },
    //     formatfunction: {
    //       viewItem: viewItem,
    //     //   editItem: editItem,
    //     //   deleteItem: deleteItem,
    //     },
    //   },
    // });
    temp_columns.forEach((item, index) => {
      if (item?.show === true && item?.dataField !== "user_id") {
        temp1.push(item);
      }
    });
  
    // Push "user_id" column to the second position in temp1 array
    const userColumn = {
      dataField: "user_id",
      text: "User",
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
      format: {
        type: "action",
        style: {
          width: "150px",
        },
        formatfunction: {
          viewItemProfile: viewItemProfile,
        },
      },
    };
    temp1.splice(1, 0, userColumn);
    setAllColumns(temp1);
  }, [columns_ads_log]);

  useEffect(() => {
    console.log("exportData: ", exportData);
    if (
      exportData &&
      exportData?.success &&
      exportData?.item &&
      exportData?.item?.fileName
    ) {
      window.open(
        `${UIHelpers.exportUrl}${exportData?.item?.fileName}`,
        "_blank"
      );
    }
  }, [exportData]);
  const AIDs = localStorage.getItem("AURLID");
  const applyFilter = (values) => {
    var check_type = true;
    var tampFilter = { ...filter };
    console.log("val::11::1", values);
    if (values?.dateRang) {
      tampFilter.dateRange = values.dateRang;
      setDateRange(values.dateRang);
      // Reset skip and page when date range is changed
      tampFilter.skip = 0;
      tampFilter.page = 1;
    }

    if (
      values?.dateRang &&
      values?.dateRang !== undefined &&
      values?.dateRang !== null
    ) {
      tampFilter.search.startAt = values.dateRang.from;
      tampFilter.search.endAt = values.dateRang.to;
      setDateRange(values.dateRang);
    } else {
      tampFilter.fromDate = null;
      tampFilter.toDate = null;
    }

    if (!helperFunc.isAdmin()) {
      if (!helperFunc.isButtonAccess("advertisers.advertisers.list")) {
        tampFilter.search.user = helperFunc.getUserData().id;
      }
    }
    tampFilter.search = {
      ...tampFilter.search,
      adId: AIDs,
      filter: selectedSignup?.value,
    };
    console.log("tampFilter::2", tampFilter, listLoading);
    console.log("tampFilter::2", tampFilter.search);

    setFilter(tampFilter);
    if (!listLoading && check_type) {
      setSearchApply(true);
      dispatch(actions.fetchAdsLogListList(tampFilter));
    }
  };

  const DataTablePaginationAPICall = (values) => {
    setSearchApply(true);
    var tampFilter = { ...filter };
    console.log("val::11::1", values);

    // if (values?.skip) {
    tampFilter.skip = values.skip;
    tampFilter.page = values.page;
    // }
    if (values?.limit) {
      tampFilter.limit = values.limit;
    }
    if (!helperFunc.isAdmin()) {
      if (!helperFunc.isButtonAccess("advertisers.advertisers.list")) {
        tampFilter.search.user = helperFunc.getUserData().id;
      }
    }

    setFilter(tampFilter);
    // setCount(count + 1);

    // console.log('tampFilter::', tampFilter, listLoading)
    if (!listLoading) {
      dispatch(actions.fetchAdsLogListList(tampFilter));
    }
  };

  const exportButtonCSVAPICall = () => {
    console.log("exportButtonCSVAPICall");
    var tampFilter = { ...filter };
    // dispatch(actions.fetchUsersLedgerReportExport(tampFilter));
  };

  const updatedCols = (val) => {
    let temp1 = [...val];
    // temp1.splice(1, 0, {
    //   dataField: "action",
    //   text: "Actions",
    //   sort: false,
    //   show: true,
    //   format: {
    //     type: "action",
    //     style: {
    //       width: "150px",
    //     },
    //     formatfunction: {
    //       viewItem: viewItem,
    //     //   editItem: editItem,
    //     //   deleteItem: deleteItem,
    //     },
    //   },
    // });
    //console.log("item::12", temp1)
    setAllColumns(temp1);
  };

  const updatedFields = (allTempFields) => {
    let temp = [];
    let selectedFields = {};
    allTempFields.map((item, index) => {
      temp.push(item.dataField);
      selectedFields[item?.dataField] = 1;
    });

    var tampFilter = { ...filter };
    tampFilter.fields = selectedFields;
    setFilter(tampFilter);
    if (!listLoading) {
      dispatch(actions.fetchAdsLogListList(tampFilter));
    }
  };

  const createFormInputs = () => {
    return (
      <div
        className="report-filter-bLock border-0 row align-items-center"
        style={{ padding: "0px 0", margin: "0px" }}
      >
        <Formik
          initialValues={{ dateRang: dateRange }}
          onSubmit={(values) => {
            console.log("val::22", values);
            applyFilter(values);
          }}
        >
          {({ handleSubmit, values }) => (
            <div className="col-lg-12 col-md-12">
              {/* <div className="row m-0 p-0"> */}
              <form
                onSubmit={handleSubmit}
                className="form form-filter w-100"
                autoComplete="off"
              >
                <div className="form-group row m-0 align-items-center z-index: 10">
                  <div className="col-3">
                    <label>Date Range</label>
                    <DateRangPickerField
                      name="dateRang"
                      placeholder="Select Date Range"
                    />
                  </div>
                  <div className="col-3" style={{ maxWidth: "250px" }}>
                    <label>Filter</label>
                    <DropdownReactSelect
                      placeholder="Filter"
                      name="signupType"
                      value={selectedSignup}
                      isMulti={false}
                      isClearable={true}
                      isSearchable={true}
                      closeMenuOnSelect={true}
                      options={SignupDropdownFilterData1}
                      onChange={handleSignupChange}
                    />
                  </div>
                  <div className="justify-content-end mx-2">
                    <button
                      type="submit"
                      className="btn btn-dark"
                      style={{ width: "130px", marginTop: "20px" }}
                    >
                      Search
                    </button>
                  </div>
                  <div
                    className="col-lg-7 col-md-7  mt-2 d-flex justify-content-end"
                    style={{ left: "104px" }}
                  >
                    <div className=""></div>
                  </div>
                </div>
              </form>
              {/* </div> */}
            </div>
          )}
        </Formik>
      </div>
    );
  };

  return (
    <Card className="">
      <NotificationContainer />
      <div className="card-header p-0">
        <div className="my-5 w-100 row mx-auto">{createFormInputs()}</div>
      </div>

      <CardBody className="p-0">
        {searchApply === true ? (
          listLoading === false && totalCount === 0 ? (
            UIHelpers.dataTableNoData()
          ) : (
            <DataTable
              rows={rows ? rows : []}
              columns={allColumns}
              paginantionTotalAmountOfData={totalCount}
              DataTablePaginationAPICall={DataTablePaginationAPICall}
            />
          )
        ) : (
          ""
        )}
      </CardBody>
    </Card>
  );
}
